import { apiFetch } from "../utils/apiFetch"

export function savePatentApplicationDraft(data: any) {
  return apiFetch("/api/patent-applications", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getPatentApplicationDrafts() {
  return apiFetch("/api/patent-applications")
}

export function getPatentApplicationById(id: string) {
  return apiFetch(`/api/patent-applications/${id}`)
}

export function updatePatentApplicationDraft(id: string, data: any) {
  return apiFetch(`/api/patent-applications/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function updatePatentApplicationStatus(id: string, status: string) {
  return apiFetch(`/api/patent-applications/${id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status })
  })
}

export function validatePatentApplication(id: string) {
  return apiFetch(`/api/euipo/patent-filing/validate/${id}`, {
    method: "POST"
  })
}

// Admin-only (SCRUM-86): sends the application to the real EPO OLF2.0 demo
// API, separate from the simulated submit flow real customers go through.
export function testRealEpoImport(id: string) {
  return apiFetch(`/api/euipo/patent-filing/test-real-epo-import/${id}`, {
    method: "POST"
  })
}

export function submitPatentApplication(id: string) {
  return apiFetch(`/api/euipo/patent-filing/submit/${id}`, {
    method: "POST"
  })
}

export function deletePatentApplicationDraft(id: string) {
  return apiFetch(`/api/patent-applications/${id}`, { method: "DELETE" })
}

export function duplicatePatentApplicationDraft(id: string) {
  return apiFetch(`/api/patent-applications/${id}/duplicate`, { method: "POST" })
}
